import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from "react-data-table-component";
import DatosSocio from "../../generico/DatosSocio";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import ComprobantesServices from "../../../services/consultas/comprobantesServices";
import ComprobantePagoQRServices from "../../../services/consultas/ComprobantePagoQRService";
import Popup from "react-popup";
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

export default class PagoQr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaPagoQr: [],
      listaPeriodo: [],
      periodoElegido: null,
    };
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {
    this.obtenerPeriodo();
  }

  obtenerPeriodo = () => {
    var lista = [];
    lista.push({
      value: null,
      label: "--Seleccione--",
    });

    var now = new Date();
    var mes = now.getMonth() + 1;
    var anio = now.getFullYear();

    var mesChar = "";
    for (var i = 0; i < 12; i++) {
      if (mes === 0) {
        mes = 12;
        anio = anio - 1;
      }
      mesChar = mes.toString().length === 1 ? "0" + mes : mes;
      lista.push({
        value: mesChar + "/" + anio,
        label: mesChar + "/" + anio,
      });
      mes = mes - 1;
    }
    this.setState({ listaPeriodo: lista });
    return lista;
  };

  handleChangeSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        listaPagoQr: [],
        periodoElegido: null,
      });
    else {
      this.setState({
        periodoElegido: selectedOption.value,
      });
    }
  };

  getColumn() {
    return [
      {
        name: "Fecha",
        selector: row => row.fecha,
        width: "100px",
      },
      {
        name: "Comercio",
        selector: row => row.comercio,
        width: "180px",
      },
      {
        name: "Documento",
        selector: row => row.documento,
        width: "130px",
      },
      {
        name: "Monto",
        selector: row => row.monto,
        width: "150px",
        right: true,
      },
      {
        name: "Forma de Pago",
        selector: row => row.formaPago,
        width: "160px",
      },
      {
        name: "Detalle",
        selector: row => row.detalle,
        width: "220px",
      },
      {
        cell: (row) => (
          <div>
            <button
              ref={() => this.PagoQrSel}
              id={row.id}
              key={row.id}
              className="btn btn-xs btn-outline-success"
              value={row.id}
              target="_blank"
              onClick={this.selDescarga}>
              {" "}
              <i className="fa fa-download" /> <b>Descargar</b>
            </button>
          </div>
        ),
      },
    ];
  }

  obtenerListaPagoQr = async () => {
    var listaPagoQr = [];
    if (this.state.periodoElegido !== null) {
      var anioMes = this.state.periodoElegido;
      await trackPromise(
        ComprobantePagoQRServices.listaComprobantePagoQR(anioMes)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            if (jsonData.codigoRetorno === "0") {
              let lista = jsonData.datos;
              for (var i = 0; i < lista.length; i++) {
                listaPagoQr.push({
                  id: lista[i].nroOperacion,
                  comercio: lista[i].comercio,
                  documento: lista[i].documento,
                  montoOriginal: formatoSeparadorMilesValue(lista[i].monto),
                  monto: formatoSeparadorMilesValue(lista[i].monto) + " " + this.obtenerMonedaFormat(lista[i].moneda),
                  fecha: lista[i].fecha,
                  formaPago: this.obtenerFormaPagoFormat(lista[i].tipoCuentaOrigen),
                  detalle: this.obtenerDetallePagoFormat(lista[i].tipoCuentaOrigen, lista[i].cuentaOrigen)
                });
              }
              if (lista.length === 0) {
                Popup.queue(this.notifiPopup("Info", "No existen registros en el mes seleccionado"));
                return;
              }
            } else {
              Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
              return;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
      );
    }
    this.setState({ listaPagoQr: listaPagoQr });

  };


  obtenerMonedaFormat(moneda) {
    switch (moneda) {
      case "GUA":
        return "GS."
      default:
        return ""
    }
  }

  obtenerFormaPagoFormat(formaPago) {
    switch (formaPago) {
      case "TCO":
        return "TARJETA"
      case "CCAHOO":
        return "CUENTA DE AHORRO"
      default:
        return "";
    }
  }

  obtenerDetallePagoFormat(formaPago, cuentaOrigen) {
    let detalle = cuentaOrigen + " - ";
    if (this.obtenerFormaPagoFormat(formaPago) === "TARJETA") {
      return detalle += this.obtenerTipoTarjeta(cuentaOrigen);
    } else {
      return detalle += "VISTA NORMAL";
    }
  }

  obtenerTipoTarjeta(nroTarjeta) {
    var prefijo = nroTarjeta.substring(0, 4);
    if (prefijo === "5150" || prefijo === "5418" || prefijo === "5358" || prefijo === "5402") {
      return "MASTER";
    }
    if (prefijo === "6020") {
      return "PANAL";
    }
    if (prefijo === "5896" || prefijo === "6042") {
      return "CABAL";
    }
  }

  ////// DESCARGA /////

  selDescarga = (e) => {
    var operacion = e.currentTarget.value;
    let item = this.state.listaPagoQr.find(element => element.id === operacion);
    this.descargar(item);
  };

  descargar(row) {
    var data = JSON.stringify({
      titulo: "Pagos con Código QR",
      nroOperacion: row.id,
      nroSocioTitular: authService.getSocio().numeroSocio.trim() + " - " + authService.getSocio().nombreCompleto,
      formaPago: row.formaPago,
      formaPagoDetalle: row.detalle,
      comercio: row.comercio,
      documento: row.documento,
      monto: row.montoOriginal,
      fechaOperacion: row.fecha
    });
    trackPromise(
      ComprobantesServices.descagarComprobantePagoQR(data)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  };

  render() {
    var periodo = this.state.listaPeriodo;
    if (this.state.listaPeriodo.length === 0) periodo = this.state.listaPeriodo;

    return (
      <div className="content-wrapper">
        <Titulo texto="Pagos por Código QR" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{ zIndex: 1 }}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="input-label-bold">Mes *</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <Select
                            required="true"
                            placeholder="-- Seleccione --"
                            onChange={this.handleChangeSelector}
                            options={periodo}
                            isClearable
                            noOptionsMessage={() => "SIN DATOS"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <button
                          className="btn btn-cu-primary"
                          onClick={() => this.obtenerListaPagoQr()}
                        >
                          <FontAwesomeIcon icon={faCheck} />  Consultar
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            {this.dibujarListaPagoQR()}
          </div>
        </section>
      </div>
    );

  }

  dibujarListaPagoQR() {
    if (
      this.state.listaPagoQr === undefined ||
      this.state.listaPagoQr.length === 0
    ) {
      return <div></div>;
    }

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <DatosSocio />
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <DataTable
                      noHeader={true}
                      pagination={true}
                      columns={this.getColumn()}
                      data={this.state.listaPagoQr}
                      dense={true}
                      striped={true}
                      paginationComponentOptions={paginationOptions}
                      noDataComponent="no hay registros para mostrar"
                      expandableRowss
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}
